import { useState, useEffect, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { Switch } from '@headlessui/react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import Home from "./pages/home";
import Portfolio from "./pages/portfolio";
import About from "./pages/about";
import Chat from "./pages/chat";
import Game from './pages/game';
import Support from './pages/support';
import Terms from './pages/terms';
import WorldCup from "./pages/worldcup"
import TCs from './pages/components/Terms'

function getSessionStorageOrDefault(key, defaultValue) {
    const stored = sessionStorage.getItem(key);
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function App() {
    const [principal, setPrincipal] = useState(undefined);
    const [enabled1, setEnabled1] = useState(false)
    const [enabled2, setEnabled2] = useState(false)
    const [showTCs, setShowTCs] = useState(false)
    const [verified, setVerified] = useState(
        getSessionStorageOrDefault('age', false)
    );

    useEffect(() => {
        sessionStorage.setItem('age', JSON.stringify(verified));
    }, [verified]);

    if (!verified) {
        if (!showTCs) {
            return (
                <>
                    <Transition.Root show={!verified} as={Fragment}>
                        <Dialog as="div" className="relative z-10" onClose={() => null}>
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                            </Transition.Child>
                            <div className="fixed justify-center inset-0 z-10 overflow-y-auto">
                                <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center">
                                    <Transition.Child
                                        as={Fragment}
                                        enter="ease-out duration-300"
                                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    >
                                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                            <div className="bg-white px-4 p-5">
                                                <div className="sm:flex sm:items-start">
                                                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                                        <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                                                    </div>
                                                    <div className="py-2 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                        <Dialog.Title as="h3" className="text-xl font-medium leading-6 text-gray-900">
                                                            Verification
                                                        </Dialog.Title>
                                                        <div class="pt-4 pl-6 grid grid-cols-3 gap-x-6 gap-y-1">
                                                            <div class="col-span-2 text-black">
                                                                <span className="text-sm font-medium text-gray-600">I am over 18 years of age</span>
                                                            </div>
                                                            <div class="text-black">
                                                                <Switch
                                                                    checked={enabled1}
                                                                    onChange={setEnabled1}
                                                                    className={classNames(
                                                                        enabled1 ? 'bg-indigo-600' : 'bg-gray-200',
                                                                        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'
                                                                    )}
                                                                >
                                                                    <span className="sr-only">Use setting</span>
                                                                    <span
                                                                        className={classNames(
                                                                            enabled1 ? 'translate-x-5' : 'translate-x-0',
                                                                            'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                                                        )}
                                                                    >
                                                                        <span
                                                                            className={classNames(
                                                                                enabled1 ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200',
                                                                                'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                                                                            )}
                                                                            aria-hidden="true"
                                                                        >
                                                                            <svg className="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                                                                                <path
                                                                                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth={2}
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                        </span>
                                                                        <span
                                                                            className={classNames(
                                                                                enabled1 ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100',
                                                                                'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                                                                            )}
                                                                            aria-hidden="true"
                                                                        >
                                                                            <svg className="h-3 w-3 text-indigo-600" fill="currentColor" viewBox="0 0 12 12">
                                                                                <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                                                            </svg>
                                                                        </span>
                                                                    </span>
                                                                </Switch>
                                                            </div>
                                                            <div class="col-span-2 text-black">
                                                                <span className="text-sm font-medium text-gray-600">I accept the <button className='underline' onClick={setShowTCs}>Terms and Conditions</button></span>
                                                            </div>
                                                            <div class="text-black">
                                                                <Switch
                                                                    checked={enabled2}
                                                                    onChange={setEnabled2}
                                                                    className={classNames(
                                                                        enabled2 ? 'bg-indigo-600' : 'bg-gray-200',
                                                                        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'
                                                                    )}
                                                                >
                                                                    <span className="sr-only">Use setting</span>
                                                                    <span
                                                                        className={classNames(
                                                                            enabled2 ? 'translate-x-5' : 'translate-x-0',
                                                                            'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                                                        )}
                                                                    >
                                                                        <span
                                                                            className={classNames(
                                                                                enabled2 ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200',
                                                                                'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                                                                            )}
                                                                            aria-hidden="true"
                                                                        >
                                                                            <svg className="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                                                                                <path
                                                                                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth={2}
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                        </span>
                                                                        <span
                                                                            className={classNames(
                                                                                enabled2 ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100',
                                                                                'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                                                                            )}
                                                                            aria-hidden="true"
                                                                        >
                                                                            <svg className="h-3 w-3 text-indigo-600" fill="currentColor" viewBox="0 0 12 12">
                                                                                <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                                                            </svg>
                                                                        </span>
                                                                    </span>
                                                                </Switch>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                                <button
                                                    type="button"
                                                    disabled={!enabled1 && !enabled2}
                                                    className={classNames(
                                                        enabled1 && enabled2 ? "inline-flex w-full justify-center rounded-md border border-transparent bg-purple-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" : "inline-flex w-full justify-center rounded-md border border-transparent bg-gray-400 px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                                                    )}
                                                    onClick={() => setVerified(true)}
                                                >
                                                    Confirm
                                                </button>
                                            </div>
                                        </Dialog.Panel>
                                    </Transition.Child>
                                </div>
                            </div>
                        </Dialog>
                    </Transition.Root>
                </>
            )
        }
        if (showTCs) {
            return (
                <div>
                    <header
                        className="sticky top-0 z-50" >
                        <button className='bg-white w-full p-4 text-4xl font-medium text-purple-600 hover:text-indigo-500' onClick={() => setShowTCs(false)}><span aria-hidden="true"> &larr;</span>BACK</button>
                    </header>
                    <TCs />
                </div>
            )
        }
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home principal={principal} setPrincipal={setPrincipal} />} />
                <Route path="/home" element={<Home principal={principal} setPrincipal={setPrincipal} />} />
                <Route path="/about" element={<About principal={principal} setPrincipal={setPrincipal} />} />
                <Route path="/game" element={<Game principal={principal} setPrincipal={setPrincipal} />} />
                <Route path="/portfolio" element={<Portfolio principal={principal} setPrincipal={setPrincipal} />} />
                <Route path="/worldcup" element={<WorldCup principal={principal} setPrincipal={setPrincipal} />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/support" element={<Support />} />
                <Route path="/chat" element={<Chat principal={principal} setPrincipal={setPrincipal} />} />
                {/* <Route path="/error" element={<Error />} /> */}
            </Routes>
        </BrowserRouter>
    )
}